/**
 * krypton API
 * Documentation of API endpoints of krypton
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { GenerateReportsCreate500ResponseErrorsInner } from '../models/GenerateReportsCreate500ResponseErrorsInner';
import { HttpFile } from '../http/http';

export class GenerateReportsCreate500Response {
    'type'?: string;
    'errors'?: Array<GenerateReportsCreate500ResponseErrorsInner>;

    static readonly discriminator: string | undefined = undefined;

    static readonly mapping: {[index: string]: string} | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "type",
            "baseName": "type",
            "type": "string",
            "format": ""
        },
        {
            "name": "errors",
            "baseName": "errors",
            "type": "Array<GenerateReportsCreate500ResponseErrorsInner>",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return GenerateReportsCreate500Response.attributeTypeMap;
    }

    public constructor() {
    }
}
